<template>
    <el-dialog
        title="关联试用客户数"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose"
        :close-on-click-modal="false">

        <el-table
            :data="customerList"
            border
            v-loading="loading"
            :header-cell-style="{background: '#f5f7fa', color: '#333'}">

            <el-table-column prop="customer_name" label="客户名称" align="center"></el-table-column>
            <el-table-column prop="user_name" label="业务员" align="center"></el-table-column>
            <el-table-column prop="branch_name" label="所属部门" align="center"></el-table-column>

            <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="viewCustomerDetail(scope.row)">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <span class="pagination-info">共 {{ pagination.total }} 条</span>

            <el-pagination
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :page-sizes="[20, 50, 100]"
                layout="sizes, prev, pager, next, jumper"
                :total="pagination.total"
                small>
            </el-pagination>
        </div>

    </el-dialog>
</template>

<script>
import ClueCount from "~/services/ClueCount";

export default {
    name: "CycleCustomerListDialog",
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialogVisible: true,
            loading: false,
            customerList: [],
            pagination: {
                page: 1,
                pageSize: 20,
                total: 0
            }
        };
    },
    mounted() {
        this.getCustomerList();
    },
    methods: {
        getCustomerList() {
            this.loading = true;

            const requestParams = {
                ...this.params,
                page: this.pagination.page,
                pageSize: this.pagination.pageSize
            };

            // 根据不同的cycle_type调用不同的接口
            let apiPath = '';
            switch(this.params.cycle_type) {
                case 'trial':
                    apiPath = 'cycle-trial-customer-list';
                    break;
                case 'effective':
                    apiPath = 'cycle-effective-customer-list';
                    break;
                case 'success':
                    apiPath = 'cycle-success-customer-list';
                    break;
                default:
                    apiPath = 'cycle-customer-list';
            }

            ClueCount.getList(requestParams, apiPath).then(res => {
                if (res.code === 0) {
                    this.customerList = res.data.list || res.data || [];
                    this.pagination.total = res.data.total || this.customerList.length;
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.loading = false;
            }).catch(err => {
                console.error('获取客户列表失败:', err);
                this.$message.error('获取客户列表失败');
                this.loading = false;
            });
        },

        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.page = 1;
            this.getCustomerList();
        },

        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getCustomerList();
        },

        handleClose() {
            this.dialogVisible = false;
            this.$emit('close');
        },

        viewCustomerDetail(row) {
            const routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: row.customer_id }
            });
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style scoped>
.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding: 0 10px;
}

.pagination-info {
    font-size: 14px;
    color: #606266;
}

/* 自定义分页样式 */
::v-deep .el-pagination {
    padding: 0;
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
}

::v-deep .el-pagination__sizes {
    margin-right: 10px;
}

::v-deep .el-pagination__jump {
    margin-left: 10px;
}

/* 表格样式调整 */
::v-deep .el-table th {
    font-weight: normal;
    color: #333;
}

::v-deep .el-table {
    font-size: 14px;
}

::v-deep .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__body {
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/clue/dialog/CycleCustomerListDialog.vue